module.exports = __webpack_public_path__ + "static/media/header.b9bc05a6.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/header.png
// module id = 1724
// module chunks = 0